export default __webpack_public_path__ + "static/about-us-hero-mobile-78542334cde5e0852dc38a3afff72503.mp4";